<template>
  <TariffNotificationModal
      ref="modalRef"
      title="Формируете свой тариф самостоятельно"
      @button-click="onConfirm"
      @hidden="emit('hidden')"
      button-text="Подключить"
      :max-width="450"
  >

    <template #default>
        <p class="trial-expired-modal__text mb-3">
            Пробный период закончился, вам доступно 3 ученика, чаты, учет финансов, добавление своих материалов.
        </p>
        <div class="trial-expired-modal__accent mb-3">
            Если у вас добавлено более 3 учеников, ученики сверх лимита будут автоматически перемещены в архив.
            Все созданные доски сохранятся в материалах, но доступ к ним будет ограничен до подключения опции «Онлайн-доска».
            Без подключения опции «Звонки» проведение онлайн-занятий будет недоступно.
        </div>
        <p class="trial-expired-modal__text">
            Подключите нужные опции, чтобы продолжить работу без ограничений!
        </p>
    </template>
  </TariffNotificationModal>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import TariffNotificationModal from '../../TariffNotificationModal.vue';

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

const emit = defineEmits<{
    (e: 'hidden'): void;
    (e: 'confirm'): void;
}>();

function onConfirm() {
    emit('confirm');
}

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

defineExpose({
    show: showModal,
    hide: hideModal,
});

</script>

<style lang="scss" scoped>
.trial-expired-modal__text {
    font-size: 14px;
}

.trial-expired-modal__accent {
    font-size: 13px;
    color: #ffffff;
    background-color: #e763ae;
    border-radius: 8px;
    padding: 12px 16px;
}
</style>



